import {
  postUserPortfolioItem,
  patchUserPortfolioItem,
  deleteUserPortfolioItem,
  patchUserPortfolioCaseItem,
  postUserPortfolioCaseItem,
  deleteUserPortfolioCaseItem,
  getUserPortfolioItems,
  getTeamPortfolioItems,
  getTeamSlugPortfolioItems,
  getResumePortfolioItems,
  getPublicResumePortfolioItems,
  getTalentPortfolioItems,
  // getPortfolioItems,
  postUserPortfolioOrder,
  getUserPortfolioItem,
  getTeamPortfolioItem,
  getTeamSlugPortfolioItem,
  getResumePortfolioItem,
  // getPortfolioItem,
  getPublicResumePortfolioItem,
  // getTalentPortfolioItem,
  getTalentPortfolioItemByUuid,
  getUserPortfolioItemByUuid,
} from '@apis/portfolios';

import { PortfolioType } from '@hiredigital/lib/helpers/marketingEnum';

export const PortfolioResource = ['users', 'teams', 'resumes', 'portfolios'];

export const getLegacyPortfolioItemRequests = {
  [PortfolioType.USER]: getUserPortfolioItem,
  [PortfolioType.TEAM]: getTeamPortfolioItem,
  [PortfolioType.RESUME]: getResumePortfolioItem,
  [PortfolioType.PORTFOLIO]: getResumePortfolioItem, // getPortfolioItem, portfolio page is using the same endpoint as resumes
  [PortfolioType.PUBLIC_RESUME]: getPublicResumePortfolioItem,
  [PortfolioType.PUBLIC_PORTFOLIO]: getPublicResumePortfolioItem, // portfolio page is using the same endpoint as resumes
  [PortfolioType.TALENT]: getTalentPortfolioItemByUuid,
  [PortfolioType.TEAM_SLUG]: getTeamSlugPortfolioItem,
};

export const getPortfolioItemRequests = {
  [PortfolioType.USER]: getUserPortfolioItemByUuid,
  [PortfolioType.TEAM]: getUserPortfolioItemByUuid,
  [PortfolioType.RESUME]: getUserPortfolioItemByUuid,
  [PortfolioType.PORTFOLIO]: getUserPortfolioItemByUuid,
  [PortfolioType.PUBLIC_RESUME]: getUserPortfolioItemByUuid,
  [PortfolioType.PUBLIC_PORTFOLIO]: getUserPortfolioItemByUuid, // resume-preview is the only excepmtion
  [PortfolioType.TALENT]: getTalentPortfolioItemByUuid,
  [PortfolioType.TEAM_SLUG]: getUserPortfolioItemByUuid,
};

export const getPortfolioItemsRequests = {
  [PortfolioType.USER]: getUserPortfolioItems,
  [PortfolioType.TEAM]: getTeamPortfolioItems,
  [PortfolioType.RESUME]: getResumePortfolioItems,
  [PortfolioType.PORTFOLIO]: getResumePortfolioItems, // getPortfolioItems, portfolio page is using the same endpoint as resumes
  [PortfolioType.PUBLIC_RESUME]: getPublicResumePortfolioItems,
  [PortfolioType.PUBLIC_PORTFOLIO]: getPublicResumePortfolioItems, // portfolio page is using the same endpoint as resumes
  [PortfolioType.TALENT]: getTalentPortfolioItems,
  [PortfolioType.TEAM_SLUG]: getTeamSlugPortfolioItems,
};

export const postPortfolioOrderRequests = [postUserPortfolioOrder];

export const postPortfolioRequests = [postUserPortfolioItem];

export const patchPortfolioRequests = [patchUserPortfolioItem];

export const deletePortfolioRequests = [deleteUserPortfolioItem];

export const patchPortfolioCaseRequests = [patchUserPortfolioCaseItem];

export const postPortfolioCaseRequests = [postUserPortfolioCaseItem];

export const deletePortfolioCaseRequests = [deleteUserPortfolioCaseItem];
